module.exports = __webpack_public_path__ + "assets/img/thumb-Ultimate-Ears-Landing-page.ac383d1f.webp";